
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Logo extends Vue {
  @Prop({ type: Boolean, default: false }) mini!: boolean
}
